import "@/components/Interface/FormFields/ListBox/ListBox.scss";

import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Pencil } from "@/assets/icons/ds";
import { getBillingAccountLabel } from "@/components/Portal/Documents/BillingAccounts/billingAccountUtils";
import { DrAccount } from "@/services/model";

interface Props {
  dataTestid?: string;
  account: DrAccount;
  disabled?: boolean;
  onClick: () => void;
}

/**
 * The picked Vertragskonto in a ListBox-style field; reopens the picker
 * modal to change it.
 */
export const BillingAccountSelectField: FC<Props> = ({
  dataTestid,
  account,
  disabled,
  onClick,
}) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "user-account.billingAccounts.select",
  });

  return (
    <div className="listbox-container full-width">
      <div className="relative">
        <button
          data-testid={dataTestid}
          className={clsx(
            "listbox-button pr-14",
            disabled && "cursor-default opacity-25",
          )}
          type="button"
          aria-haspopup="dialog"
          disabled={disabled}
          onClick={onClick}
        >
          <span className="listbox-button__label">{t("label")}</span>
          <span className="listbox-button__value block truncate">
            {getBillingAccountLabel(account)}
          </span>
        </button>
        <div
          className={clsx(
            "icon-wrapper text-foreground-primary",
            disabled && "opacity-25",
          )}
        >
          <Pencil className="icon" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};
